<template>
  <v-dialog persistent v-model="dialog" max-width="700">
    <v-card>
      <v-card-title class="headline">
        <v-icon color="error" class="mr-2">mdi-sticker-alert</v-icon>
        mapped_core.csv not found
      </v-card-title>
      <v-card-text class="body-1">Would you like to continue?</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="error" @click="close">Cancel</v-btn>
        <v-btn text color="primary" @click="agree">Continue</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    agree() {
      this.$emit('onContinue');
      this.close();
    }
  }
};
</script>
